module.exports = __webpack_public_path__ + "static/media/CompleteCompliance.c07b08da.svg";